import { render, staticRenderFns } from "./TaskCreated.vue?vue&type=template&id=0a783290&scoped=true"
import script from "./TaskCreated.vue?vue&type=script&lang=js"
export * from "./TaskCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a783290",
  null
  
)

export default component.exports